import { css } from "../../../../styled-system/css";

export function MonthlyTransactionsSkeleton() {
  return (
    <div>
      <div
        className={css({
          pl: "12px",
        })}
      >
        <div
          className={css({
            fontSize: "18px",
            marginBottom: "12px",
            pl: "16px",
            color: "text.secondary",
            width: "100px",
            height: "24px",
            background:
              "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
            backgroundSize: "200% 600%",
            animation: "1.2s shine linear infinite",
          })}
        />
      </div>
      <div
        className={css({
          bg: "white",
          overflow: "hidden",
        })}
      >
        {[1, 2, 3].map((d, index) => (
          <div
            key={`skeleton-${d}`}
            className={css({
              display: "flex",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: index < 2 ? "1px solid #eee" : "none",
            })}
          >
            <div
              className={css({
                width: "24px",
                height: "24px",
                borderRadius: "full",
                background:
                  "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                backgroundSize: "200% 600%",
                animation: "1.2s shine linear infinite",
                mr: "16px",
              })}
            />
            <div className={css({ flex: 1 })}>
              <div
                className={css({
                  width: "120px",
                  height: "16px",
                  background:
                    "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                  backgroundSize: "200% 600%",
                  animation: "1.2s shine linear infinite",
                  rounded: "md",
                  mb: "8px",
                })}
              />
              <div
                className={css({
                  width: "160px",
                  height: "14px",
                  background:
                    "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                  backgroundSize: "200% 600%",
                  animation: "1.2s shine linear infinite",
                  rounded: "md",
                })}
              />
            </div>
            <div
              className={css({
                width: "80px",
                height: "16px",
                background:
                  "linear-gradient(110deg, #e8e8e8 8%, #f5f5f5 18%, #e8e8e8 33%)",
                backgroundSize: "200% 600%",
                animation: "1.2s shine linear infinite",
                rounded: "md",
                ml: "16px",
              })}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
